import classNames from 'classnames';

import CreateAccountLink from '~components/CustomerCenter/children/CreateAccount';
import MedicareTool from '~components/MedicareTools/MedicareToolsButton';

import DoctorIcon from './images/doctor-icon.inline.svg';
import PhoneIcon from './images/phone-icon.inline.svg';
import PillIcon from './images/pill-icon.inline.svg';

type Props = {
    heading?: string;
    doctorsectiontitle?: string;
    drugsectiontitle?: string;
    accountsectiontitle?: string;
    doctorctacopy?: string;
    drugctacopy?: string;
    accountctacopy?: string;
    backgroundsurface?: SupportedBackgroundColor;
};

const PersonalizePlanReco = ({
    heading = 'Get personalized plan recommendations',
    doctorsectiontitle = 'Make sure your doctor is covered',
    drugsectiontitle = 'Save on your prescriptions',
    accountsectiontitle = 'Pick up shopping where you left off',
    doctorctacopy = 'Add my doctors',
    drugctacopy = 'Add my Rx drugs',
    accountctacopy = 'Create account',
    backgroundsurface = 'bg-surface-100',
}: Props) => {
    return (
        <section className={classNames(backgroundsurface)}>
            <div className="max-w-1200 mx-auto px-4 py-10 md:px-6 md:py-16 lg:py-20">
                <h2 className="text-32 leading-40 font-poppins font-bold text-center text-link-visited mb-16 lg:mb-20 md:text-40 md:leading-56 lg:text-48 lg:leading-64">
                    {heading}
                </h2>
                <div className="flex flex-col md:flex-row gap-12 md:gap-6">
                    <div className="text-center flex-1 md:flex md:flex-col md:justify-between">
                        <div>
                            <DoctorIcon className="mx-auto" />
                            <p className="text-24 leading-32 font-poppins font-bold text-link-visited mt-7 mb-2.5 w-56 mx-auto">
                                {doctorsectiontitle}
                            </p>
                            <p className="text-16 leading-24 text-center text-link-visited pb-5 lg:text-18 lg:leading-28">
                                Enter your doctors and specialists to compare plans they accept.
                            </p>
                        </div>
                        <div className="flex justify-center w-full">
                            <MedicareTool
                                buttontype="secondary"
                                btnWidth="w-full md:w-auto"
                                trackingName="Personalized Plan"
                                toolname="doctor"
                                label={doctorctacopy}
                                fontSize="text-xl"
                            />
                        </div>
                    </div>
                    <div className="text-center flex-1 md:flex md:flex-col md:justify-between">
                        <div>
                            <PillIcon className="mx-auto" />
                            <p className="text-24 leading-32 font-poppins font-bold text-link-visited mt-7 mb-2.5 w-56 mx-auto">
                                {drugsectiontitle}
                            </p>
                            <p className="text-16 leading-24 text-center text-link-visited pb-5 lg:text-18 lg:leading-28">
                                Enter your prescriptions to compare plans that cover them and
                                explore opportunities for savings.
                            </p>
                        </div>
                        <div className="flex justify-center w-full">
                            <MedicareTool
                                buttontype="secondary"
                                btnWidth="w-full md:w-auto"
                                trackingName="Personalized Plan"
                                toolname="drug"
                                label={drugctacopy}
                                fontSize="text-xl"
                            />
                        </div>
                    </div>
                    <div className="text-center flex-1 md:flex md:flex-col md:justify-between">
                        <div>
                            <PhoneIcon className="mx-auto" />
                            <p className="text-24 leading-32 font-poppins font-bold text-link-visited mt-7 mb-2.5 w-56 mx-auto">
                                {accountsectiontitle}
                            </p>
                            <p className="text-16 leading-24 text-center text-link-visited pb-5 lg:text-18 lg:leading-28">
                                Save your information in one secure location and resume shopping at
                                any time.
                            </p>
                        </div>
                        <div className="flex justify-center w-full">
                            <CreateAccountLink
                                styles="w-full md:w-auto"
                                trackingName="Personalized Plan"
                                btnType="secondary"
                                guestCopy={accountctacopy}
                                authenticatedCopy="My account"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PersonalizePlanReco;
